import { IncomingMessage } from 'http'

export const REQUEST_HTML_CONTENT = 'REQUEST_HTML_CONTENT'
export const PERSIST_HTML_CONTENT = 'PERSIST_HTML_CONTENT'

export function requestHtmlContent(payload: { req?: IncomingMessage; keys: string[] }) {
  return {
    type: REQUEST_HTML_CONTENT,
    payload,
  }
}

export function persistHtmlContent(payload: { key: string; content: string }) {
  return {
    type: PERSIST_HTML_CONTENT,
    payload,
  }
}
